<greco-alert
  [config]="{
    title: 'No Profile Picture',
    type: $any('DANGER'),
    description: 'Please upload a profile picture'
  }"
>
  <button mat-flat-button color="primary" slot="buttons" (click)="upload()">Upload</button>
</greco-alert>
